import { SearchTwoTone } from '@mui/icons-material';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  TextField,
} from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function SelectFilter(props: {
  values: number[];
  options: {
    id: number;
    label: string;
  }[];
  onChange: (values: number[]) => void;
  enableSearch?: boolean;
  onSearch?: (searchTerm: string) => void;
  manualSearch?: boolean;
}) {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const options = props.manualSearch
    ? props.options
    : props.options.filter((opt) =>
        opt.label.toLowerCase().includes(searchTerm.toLowerCase()),
      );

  useEffect(() => {
    if (props.onSearch) {
      props.onSearch(searchTerm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  return (
    <Fragment>
      {props.enableSearch && (
        <TextField
          placeholder={t('selectFilter.searchPlaceholder')}
          variant="outlined"
          fullWidth
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchTwoTone />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 1 }}
        />
      )}
      <FormGroup>
        {options.map((opt) => (
          <FormControlLabel
            key={`startPlace-${opt.id}`}
            control={
              <Checkbox
                color="secondary"
                size="small"
                checked={props.values.includes(opt.id)}
                onChange={() =>
                  props.onChange(
                    props.values.includes(opt.id)
                      ? props.values.filter((id) => id !== opt.id)
                      : [...props.values, opt.id],
                  )
                }
              />
            }
            label={opt.label}
          />
        ))}
      </FormGroup>
    </Fragment>
  );
}
